import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7661d050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid bg-white h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mt-5" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Inscription")
  ])
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1))
const _hoisted_5 = { class: "col-12 col-lg-4 m-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 bg-primary rounded text-light text-start pt-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, [
      /*#__PURE__*/_createElementVNode("u", null, "Information:")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Il n'est pas possible d'utiliser la même adresse email pour plusieurs comptes. Vous pouvez utiliser une sous adresse si vous avez une adresse gmail. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Par exemple, si votre adresse email est \"monemail@gmail.com\", vous pouvez utiliser \"monemail+overrun@gmail.com\", 'overrun' étant un mot de votre choix. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1))
const _hoisted_8 = { class: "row mt-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "row m-2" }
const _hoisted_12 = { class: "col-12 col-lg form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputFirstName" }, "Prénom: ", -1))
const _hoisted_14 = { class: "col-12 col-lg form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputLastName" }, "Nom :", -1))
const _hoisted_16 = { class: "row m-2" }
const _hoisted_17 = { class: "col-12 col-lg-6 form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputEmail" }, "Email: ", -1))
const _hoisted_19 = { class: "col-12 col-lg-6 form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputPhoneNumber" }, "Téléphone: ", -1))
const _hoisted_21 = { class: "row m-2" }
const _hoisted_22 = { class: "col form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputUserName" }, "Pseudo: ", -1))
const _hoisted_24 = { class: "error" }
const _hoisted_25 = { class: "row m-2" }
const _hoisted_26 = { class: "col col-lg-6 form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputPassword" }, "Mot de passe: ", -1))
const _hoisted_28 = { class: "col col-lg-6 form-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputConfirmPassword",
  class: "d-none d-md-inline"
}, "Confirmez le mot de passe: ", -1))
const _hoisted_30 = { class: "error" }
const _hoisted_31 = { class: "row m-2" }
const _hoisted_32 = { class: "col-12 col-lg-4 form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputBirthDate" }, "Date de naissance: ", -1))
const _hoisted_34 = { class: "error" }
const _hoisted_35 = { class: "col-12 col-lg-4 form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputBirthDate" }, "Sexe: ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Femme", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Homme", -1))
const _hoisted_40 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { class: "row m-2" }
const _hoisted_42 = { class: "col form-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputAddress" }, "Adresse: ", -1))
const _hoisted_44 = { class: "row m-2" }
const _hoisted_45 = { class: "col-12 col-lg-6 form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputCity" }, "Ville: ", -1))
const _hoisted_47 = { class: "col-12 col-lg form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputZipCode" }, "Code Postal: ", -1))
const _hoisted_49 = { class: "col-12 col-lg form-group" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputCountry" }, "Pays: ", -1))
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"row m-2 mt-3\" data-v-7661d050><div class=\"col form-group\" data-v-7661d050><input id=\"checkRules\" class=\"mt-0 me-1\" type=\"checkbox\" value=\"\" aria-label=\"Checkbox for following text input\" required data-v-7661d050><label for=\"checkRules\" data-v-7661d050> J&#39;ai lu et j&#39;accepte le <a href=\"https://links.24heures.org/reglement-courses\" target=\"_blank\" data-v-7661d050>règlement en vigueur</a> . </label></div></div>", 1)
const _hoisted_52 = { class: "row m-2 mt-5" }
const _hoisted_53 = { class: "col form-group text-end" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepBar = _resolveComponent("StepBar")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_StepBar, { index: 1 })
        ]),
        _hoisted_6
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("form", {
            class: "text-start mb-5 fw-bold",
            onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputFirstName",
                  minlength: "3",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputLastName",
                  minlength: "3",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.lastName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email",
                  class: "form-control",
                  id: "inputEmail",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  title: "Le numéro peut inclure des espaces et/ou un indicatif de pays",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phoneNumber) = $event)),
                  type: "tel",
                  pattern: "(\\+|)[0-9 ]*",
                  class: "form-control",
                  id: "inputPhoneNumber",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.phoneNumber]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.username) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputUserName",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.username]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_24, " Le pseudo choisi n'est pas disponible. Merci d'en choisir un différent. ", 512), [
                  [_vShow, _ctx.duplicatePseudo]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password) = $event)),
                  type: "password",
                  class: "form-control",
                  id: "inputPassword",
                  minlength: "8",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  id: "inputConfirmPassword",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                  minlength: "8",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.confirmPassword]
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_30, " Les mots de passe ne correspondent pas ", 512), [
                [_vShow, _ctx.password !== _ctx.confirmPassword]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.birthDate) = $event)),
                  type: "date",
                  class: "form-control",
                  id: "inputBirthDate",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.birthDate]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_34, " La date est incorrecte! ", 512), [
                  [_vShow, !_ctx.dateIsCorrect()]
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sex) = $event)),
                  class: "form-select",
                  "aria-label": "Default select example",
                  required: ""
                }, _hoisted_40, 512), [
                  [_vModelSelect, _ctx.sex]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.address) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputAddress",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.address]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.city) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputCity",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.city]
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.zipCode) = $event)),
                  title: "Le code postal doit contenir une suite de chiffres uniquement",
                  type: "text",
                  class: "form-control",
                  id: "inputZipCode",
                  pattern: "[0-9]*",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.zipCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.country) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputCountry",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.country]
                ])
              ])
            ]),
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "submit",
                  disabled: 
                  _ctx.password !== _ctx.confirmPassword ||
                  !_ctx.dateIsCorrect() ||
                  _ctx.duplicatePseudo ||
                  _ctx.showErrorModal
                
                }, " S'inscrire ", 8, _hoisted_54)
              ])
            ])
          ], 32)
        ]),
        _hoisted_55
      ])
    ]),
    _withDirectives(_createVNode(_component_Error, { onCloseErrorModal: _ctx.toggleErrorModal }, null, 8, ["onCloseErrorModal"]), [
      [_vShow, _ctx.showErrorModal]
    ])
  ], 64))
}